import { render } from "./App.vue?vue&type=template&id=1f4ffad5"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1f4ffad5&lang=css"

import exportComponent from "/home/runner/work/tunescrib-rs/tunescrib-rs/dev.tunescrib.com-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__